import axios from 'axios'
import { getPbToken, removePbToken } from '../utils/authTokenStorage'

// Во всех режимах используем относительный путь: в production его обслуживает nginx,
// а в development — Vite proxy. Это сохраняет один origin и не вызывает CORS-ошибку.
const envViteApiUrl = import.meta.env.VITE_API_URL;
const computedBaseURL = envViteApiUrl || '/api';
const apiBaseURL = computedBaseURL;

const api = axios.create({
  baseURL: apiBaseURL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
  withCredentials: true
})

// Interceptor для автоматического добавления токена к каждому запросу
api.interceptors.request.use(
  (config) => {
    const token = getPbToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // Если данные - FormData, удаляем Content-Type чтобы браузер установил правильный заголовок с boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    // Добавляем timestamp к GET запросам для предотвращения кеширования браузером
    if ((config.method === 'get' || !config.method) && config.url) {
      // Простое добавление timestamp параметра
      const separator = config.url.includes('?') ? '&' : '?'
      // Удаляем старый _t если есть и добавляем новый
      const urlWithoutOldT = config.url.replace(/[?&]_t=\d+/g, '')
      const separatorForNewT = urlWithoutOldT.includes('?') ? '&' : '?'
      config.url = `${urlWithoutOldT}${separatorForNewT}_t=${Date.now()}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor для обработки ошибок авторизации
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Токен недействителен, удаляем его
      removePbToken()
      delete api.defaults.headers.common['Authorization']
      // Перенаправляем на страницу входа если не на ней
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// Добавляем токен при инициализации если есть
const bootToken = getPbToken()
if (bootToken) {
  api.defaults.headers.common['Authorization'] = `Bearer ${bootToken}`
}

/** Базовый URL для статики (uploads) без /api. В браузере используем текущий origin, чтобы /uploads шёл на тот же хост (vite proxy в dev, nginx proxy в prod). */
export function getStaticBaseURL() {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  const b = api.defaults.baseURL || ''
  const base = b.endsWith('/api') ? b.slice(0, -4) : (b.replace(/\/api\/?$/, '') || 'http://localhost:8083')
  return base || 'http://localhost:8083'
}

/** Нормализует URL аватара: localhost без порта или относительный путь → текущий origin API */
export function normalizeAvatarUrl(url) {
  if (!url || typeof url !== 'string') return url
  const base = getStaticBaseURL()
  if (url.startsWith('/')) return base + url
  try {
    const u = new URL(url)
    if (u.hostname === 'localhost' && (u.port === '' || u.port === '80')) {
      return base + u.pathname + u.search
    }
  } catch (_) {}
  return url
}

export default api
